import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {NavItem} from '../../Interfaces/NavItem';
import {SharedVarService} from '../shared-service.service';
import {animate, keyframes, state, style, transition, trigger} from '@angular/animations';
import {AppComponent} from '../../app.component';

@Component({
  selector: 'app-menus',
  templateUrl: './menus.component.html',
  styleUrls: ['./menus.component.css'],

})
export class MenusComponent implements OnInit {
  @Input() myMenus: NavItem[];
  @ViewChild('mainPanel') mainPanel;
  isOpen: boolean = true;
  className: string = null;

  hideMenus(){
    this.globalEventsManager.menuFound.emit(false);
    this.mainPanel.close();

    this.myApp.accPanel.close();
    this.myApp.accOpen = false;
    this.myApp.helpPanel.close();
    this.myApp.helpOpen = false;


  }

  constructor(private  globalEventsManager: GlobalEventsManager, private service: SharedVarService, public myApp:AppComponent) {


  }

  ngOnInit() {
    this.service.killSubscription(true);

  }



}
